<template>
  <v-dialog
    :eager="eager"
    v-model="show"
    @keydown.esc="closeOnEscape()"
    persistent
    scrollable
    :fullscreen="fullscreen"
    :max-width="maxWidth"
  >
    <v-card>
      <v-card-title class="pt-3">
        <span class="headline">{{ title }}</span>
        <span v-if="infoText">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon style="position:initial" class="mb-1">mdi-information</v-icon>
              </v-btn>
            </template>
            <span>{{ infoText }}</span>
          </v-tooltip>
        </span>
        <v-spacer />
        <v-icon aria-label="Close" @click.prevent="onCancel()"
          >mdi-close</v-icon
        >
      </v-card-title>
      <v-card-text class="pt-1 pb-0">
        <div class="text-center ma-10" v-if="loadingContent">
          <v-progress-circular
            color="primary"
            size="100"
            indeterminate
          ></v-progress-circular>
        </div>
        <slot v-else />
      </v-card-text>
      <v-card-actions class="pt-0 pb-3 mt-3">
        <slot name="footer" />
        <v-spacer></v-spacer>
        <v-btn
          v-if="showCancelButton"
          small
          class="pa-4 text-capitalize font-weight-regular display-1"
          @click.prevent="onCancel()"
          >{{ closeText }}</v-btn
        >
        <v-btn
          v-if="showConfirmButton"
          color="primary"
          small
          class="pa-4 text-capitalize font-weight-regular display-1"
          :loading="loading"
          @click.prevent="onConfirm()"
          >{{ okText }}</v-btn
        >
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ModalBase",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    closeWithEscape: {
      type: Boolean,
      default: true,
    },
    showConfirmButton: {
      type: Boolean,
      default: true,
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    eager: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [String, Number],
      default: "600",
    },
    title: {
      type: String,
      default: "",
    },
    closeText: {
      type: String,
      default: function () {
        return this.$t("Close");
      },
    },
    okText: {
      type: String,
      default: function () {
        return this.$t("Save");
      },
    },
    loadingContent: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    infoText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    closeOnEscape() {
      if (this.closeWithEscape) {
        show = false;
      }
    },
    onCancel() {
      this.$emit("on-cancel");
    },
    onConfirm(event) {
      this.$emit("on-confirm");
    },
    progress(show) {
      this.loading = show;
    },
  },
};
</script>
